module.exports = __webpack_public_path__ + "static/media/slogan_hero_dark.fe77fc60.svg";